import { DateType, User } from '../models';

export enum ApprovalStatus {
  ApprovalRequested = 'APPROVAL_REQUESTED',
  ChangeRequested = 'CHANGE_REQUESTED',
  Approved = 'APPROVED',
}

export interface ApprovalRequestTo {
  userId: number;
  approvalStatus: ApprovalStatus;
  updatedAt?: number;
  updateAt?: number;
}

export interface ApprovalComment {
  commentId: number;
  content?: string | null;
  createdBy: number;
  createdAt: number;
  private: boolean;
}

export interface Approval {
  approvalId: number;
  dueDate?: DateType | null;
  requestBy: User;
  requestTo: Array<ApprovalRequestTo>;
  comments?: Array<ApprovalComment>;
  private: boolean;
  createdAt: number;
}

export type CreateApprovalPayload = Pick<
  Approval,
  'private' | 'requestBy' | 'requestTo' | 'dueDate'
> & {
  comment?: Pick<ApprovalComment, 'content'>;
};

export type UpdateApprovalPayload = Pick<
  CreateApprovalPayload,
  'requestTo' | 'comment'
> & {
  approvalId: number;
};
